export const SETTINGS_SECTION_WRAPPER_CLASSNAME = 'grid grid-cols-[auto] gap-6 md:grid-cols-[420px_auto]'

export const SETTINGS_CARD_WRAPPER_CLASSNAME =
    'flex flex-col items-start gap-1.5 rounded-xl bg-white p-4 text-sm md:flex-row md:items-center [&_h3]:text-neutral-700 w-fit'

export const SETTINGS_CARD_COMPLETED_CLASSNAME = 'p-0 [&_h3]:text-lg [&_span]:text-md'

export const SETTINGS_AREA_DASHED_BORDER_BACKGROUND =
    "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23D0D5DD' stroke-width='1' stroke-dasharray='5%2c 5' stroke-dashoffset='25' stroke-linecap='butt'/%3e%3c/svg%3e\")"

export const SETTINGS_CARD_DASHED_BORDER_BACKGROUND =
    "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23D0D5DD' stroke-width='1' stroke-dasharray='5%2c 5' stroke-dashoffset='25' stroke-linecap='butt'/%3e%3c/svg%3e\")"
